import { render } from "./to_mail.vue?vue&type=template&id=131dd95e&scoped=true"
import script from "./to_mail.vue?vue&type=script&lang=js"
export * from "./to_mail.vue?vue&type=script&lang=js"

import "./to_mail.vue?vue&type=style&index=0&id=131dd95e&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131dd95e"]])

export default __exports__